import util from '@/libs/util.js'
import storejs from 'store'
import { AccountLogin } from '@/api/sys.login'
import axios from 'axios'

export default {
  namespaced: true,
  actions: {
    /**
     * @description 登录
     * @param {Object} param context
     * @param {Object} param vm {Object} vue 实例
     * @param {Object} param username {String} 用户账号
     * @param {Object} param password {String} 密码
     * @param {Object} param route {Object} 登录成功后定向的路由对象 任何 vue-router 支持的格式
     */
    login ({ dispatch }, {
      // vm,
      mobile,
      password,
      randomString,
      uuids,
      state,
      VerificationCode,
    }) {
      return new Promise((resolve, reject) => {
        // 开始请求登录接口
        AccountLogin({
          mobile,
          password,
          randomString,
          uuids,
          state,
          VerificationCode
        })
          .then(async res => {
            console.log('res',res)
            if ( res.code === 0 ) {
              // 设置 cookie 一定要存 uuid 和 token 两个 cookie
              // 整个系统依赖这两个数据进行校验和存储
              // uuid 是用户身份唯一标识 用户注册的时候确定 并且不可改变 不可重复
              // token 代表用户当前登录状态 建议在网络请求中携带 token
              // 如有必要 token 需要定时更新，默认保存一天
              util.cookies.set('uuid', res.t.uid);
              util.cookies.set('token', res.t.token);
              //把权限写入storejs
              let permissionsArr = []
              res.t.trees.forEach(element => {
                permissionsArr.push(element.name)
              });
              storejs.set('permissions', permissionsArr);
              //把iid写入storejs
              // storejs.set('iid', res.t.iid);
              //把所有信息都写入storejs备用
              storejs.set('publicData', res.t);
              // 设置 vuex 用户夕
              // await dispatch('d2admin/user/set', {
              //   name: res.t.name,
              //   // mobile:res.t.mobile,
              //   // loginTime:res.t.loginTime,
              //   // isRenZheng:renzhengFlag,
              //   // shareColor:res.t.accountBasic.shareColor,
              //   // shareLogo:res.t.accountBasic.shareLogo
              // }, { root: true })
              // 用户登录后从持久化数据加载一系列的设置
              // await dispatch('load')
              // 结束
              resolve(res)
            } else {
              reject(res)
            }
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    /**
     * @description 注销用户并返回登录页面
     * @param {Object} param context
     * @param {Object} param vm {Object} vue 实例
     * @param {Object} param confirm {Boolean} 是否需要确认
     */
    logout ({ commit }, { vm, confirm = false }) {
      /**
       * @description 注销
       */
      async function logout () {
        await axios.post("/logout")
        // 删除cookie
        util.cookies.remove('token')
        util.cookies.remove('uuid')
        // 跳转路由
        vm.$router.push({
          name: 'login'
        });
      }
      // 判断是否需要确认
      if (confirm) {
          
        
      } else {
        logout()
      }
    },
  }
}
